const dataLayerName = 'gtmEventsDataLayer';
const eventNamespace = '.gtm';
const booleanParams = ['uaNonInt'];

function buildEvent(GTMEvent, params) {
    let ret = {
        event: GTMEvent.GTMEvent
    };

    ret.eventLabel = GTMEvent.GTMLabel || "";

    $.extend(ret, params);
    return ret;
}

function pushEvent(eventToPush) {
    if (typeof(window.dataLayer) !== 'undefined') {
        window.dataLayer.push(eventToPush);
    } else {
        window.dataLayer = [eventToPush];
    }
}

function parseParams(paramString) {
    let params = paramString.split(';');
    let ret = {};

    params.forEach(val => {
        let param = val.split('=');
        // boolean is expected for this param
        if (param[0] && booleanParams.indexOf(param[0]) !== -1) {
            ret[param[0]] = (param[1] === 'true');
        } else {
            ret[param[0]] = param[1];
        }
    });

    return ret;
}

function needsCallback($elem) {
    return ($elem.is('a') && $elem.attr('href') && $elem.attr('href').indexOf('#') !== 0 && $elem.attr('target') !== '_blank') ||
        ($elem.attr('type') === 'submit');
}

export default class GTM {

    trackEvent(eventName, eventLabel, params, callback = null) {
        this.handleEventsGTMlinkedToActions(eventName);
        let p = typeof params === 'string' ? parseParams(params || '') : params;
        let event = buildEvent({GTMEvent: eventName, GTMLabel: eventLabel}, p);
        let trackingDone = false;

        if (callback) {
            event.eventCallback = function () {
                if (!trackingDone) {
                    callback();
                    trackingDone = true;
                }
                return false;
            };

            setTimeout(() => {
                if (!trackingDone) {
                    callback();
                    trackingDone = true;
                }
                return false;
            }, 1000);
        }
        pushEvent(event);
    };

    handleEventsGTMlinkedToActions(eventName) {
        window.__eventsGTMlinkedToActions__ = window.__eventsGTMlinkedToActions__.filter(function(eventInfo){
            if(eventName === eventInfo.after) {
                let p = typeof eventInfo.params === 'string' ? parseParams(eventInfo.params || '') : eventInfo.params;
                let event = buildEvent({ GTMEvent: eventInfo.name, GTMLabel: eventInfo.label }, p);
                pushEvent(event);
                return false;
            }
            return true;
        })

    }

    invokeOtherHandlers($elem, evt) {
        if (evt.ctrlKey || evt.metaKey) {
            $elem.attr('target', '_blank');
        }

        /**
         * It looks like the default click action (navigate) doesn't work, on trigger click will trigger the event handler but doesn't follow the link
         * @see http://stackoverflow.com/questions/20928915/jquery-triggerclick-not-working
         */
        if ($elem.attr('href') && $elem.attr('href').length > 0) {
            if ($elem.attr('target') === '_blank') {
                window.open($elem.attr('href'));
            } else {
                this.changeLocation($elem.attr('href'));
            }
        } else {
            $elem.trigger(evt.type);
        }
    }

    changeLocation(href) {
        //This takes care of '<a>' click, form 'submit' won't be handled by this.
        window.location.href = href;
    }

    attachEventToDocumentReady(event) {
        $(document).ready(evt => {
            this.eventCallback(event, evt);
        });
    }

    attachEventToVisible(event) {
        const observer = new MutationObserver(mutations => {
            mutations.forEach(mutation => {
                if (mutation.type === 'attributes' && $(event.selector).is(':visible')) {
                    this.eventCallback(event, event.DOMEvent);
                }
            });
        });

        const config = { attributes: true, childList: true, characterData: true };

        $(document).ready(() => {
            observer.observe(document.querySelector(event.selector), config);
        });
    }

    attachEventToDOMElement(event) {
        $(document)
            .off(event.DOMEvent + eventNamespace, event.selector)
            .on(event.DOMEvent + eventNamespace, event.selector, evt => {
                this.eventCallback(event, evt);
            });
    }

    attachEventToNode(event) {
        $(event.selector)
            .on(event.DOMEvent + eventNamespace, evt => {
                this.eventCallback(event, evt);
            });
    }

    eventCallback(GTMEvent, DOMEvent) {
        let self = this;
        let $elem = $(DOMEvent.currentTarget);
        let params = parseParams($elem.data('gtmParams') || '');

        if ($(GTMEvent.selector).length) {
            let eventToPush = buildEvent(GTMEvent, params);

            if (needsCallback($elem)) {
                let trackingDone = false;

                eventToPush.eventCallback = function () {
                    if (!trackingDone) {
                        self.invokeOtherHandlers($elem, DOMEvent);
                        trackingDone = true;
                    }
                    return false;
                };

                setTimeout(() => {
                    if (!trackingDone) {
                        this.invokeOtherHandlers($elem, DOMEvent);
                        trackingDone = true;
                    }
                    return false;
                }, 1000);

                DOMEvent.preventDefault();
                DOMEvent.stopPropagation();
            }

            pushEvent(eventToPush);
        }
    }

    init() {
        if ($(document).data('gtmInitialized') === true) {
            return;
        }

        window.__eventsGTMlinkedToActions__ = [];

        let events = window[dataLayerName] || [];
        $(document).off(eventNamespace);

        events.forEach(val => {
            if (val.DOMEvent === 'documentReady') {
                this.attachEventToDocumentReady(val);
            } else if (val.DOMEvent === 'visible') {
                this.attachEventToVisible(val);
            } else if (val.DOMEventOnNode === true) {
                this.attachEventToNode(val);
            } else {
                this.attachEventToDOMElement(val);
            }
        });

        $(document).data('gtmInitialized', true);
    }
}
